import React from 'react'
import { useCallback, useEffect, useRef, useState } from 'react'

import { pollAudioLevel } from './use_audio_indicator'

type Props = {
  mediaStreamTrack: MediaStreamTrack | undefined
} & React.HTMLAttributes<HTMLOrSVGElement>

export const AudioIndicatorBar = ({ mediaStreamTrack, ...props }: Props) => {
  const requestAnimateRef = useRef()
  const levelRef = useRef(0)
  const [level, setLevel] = useState(0)

  const handleLevelChanged = useCallback((l) => {
    setLevel(l)
  }, [])

  useEffect(() => {
    if (mediaStreamTrack) {
      pollAudioLevel(
        mediaStreamTrack,
        requestAnimateRef,
        handleLevelChanged,
        levelRef,
        20,
      )
    }
  }, [handleLevelChanged, mediaStreamTrack])

  return (
    <svg {...props} height={30}>
      {[...Array(10)].map((_x, i) => {
        return (
          <rect
            key={i}
            width={10}
            height={30}
            x={`calc(${i * 10}% + 10px)`}
            fill={i + 10 < level ? '#559429' : 'var(--colors-grey100)'}
            rx={5}
          />
        )
      })}
    </svg>
  )
}
